// NOTE: this file was auto-generated with `libraries/icons/src/_private/transform.ts`
// Any manual edits will be overwritten via `rush build`

import { SVGProps } from 'react';

const StarOutline = (props: SVGProps<SVGSVGElement>) => (
	<svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 96 96" {...props}>
		<path
			d="M48 72.3c.298 0 .595.065.87.198l19.918 9.625-2.57-23.039a2.006 2.006 0 0 1 .485-1.54L81.74 40.4l-21.664-4.558a2.003 2.003 0 0 1-1.353-1.015L48 14.745 37.276 34.827a1.999 1.999 0 0 1-1.353 1.015L14.259 40.4l15.038 17.143c.37.423.546.983.484 1.541l-2.57 23.04 19.919-9.626c.275-.133.572-.199.87-.199m23.176 15.2a1.99 1.99 0 0 1-.87-.199L48 76.521l-22.306 10.78a2.001 2.001 0 0 1-2.858-2.023l2.872-25.76L8.997 40.466a1.998 1.998 0 0 1 1.09-3.276l24.1-5.07L46.236 9.558a1.998 1.998 0 0 1 3.528 0l12.05 22.562 24.099 5.07a2 2 0 0 1 1.09 3.276L70.293 59.518l2.872 25.76a2 2 0 0 1-1.988 2.221"
			fillRule="evenodd"
		/>
	</svg>
);
export default StarOutline;
